import { COVERGO_CA_UAT, COVERGO_SAAS_DEV, COVERGO_ASIA_QA } from "../consts.js"

export const assa_gt_uat = {
	"assa-gt-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "assa_gt_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-assa-gt-uat"
		}
	},
}
export const assa_hn_uat = {
	"assa-hn-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "assa_hn_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-assa-hn-uat"
		}
	},
}
export const assa_dev = {
	"assa-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "assa_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-assa-dev"
		}
	},
}

export const assa_qa = {
	"assa-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "assa_qa",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-assa-qa"
		},
	},
}
